import React from 'react';

const CopyIconDouble = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.667 5.33334V4.00001C10.667 3.64638 10.5265 3.30724 10.2765 3.0572C10.0264 2.80715 9.68728 2.66667 9.33366 2.66667H4.00033C3.6467 2.66667 3.30756 2.80715 3.05752 3.0572C2.80747 3.30724 2.66699 3.64638 2.66699 4.00001V9.33334C2.66699 9.68696 2.80747 10.0261 3.05752 10.2761C3.30756 10.5262 3.6467 10.6667 4.00033 10.6667H5.33366M5.33366 6.66667C5.33366 6.31305 5.47413 5.97391 5.72418 5.72386C5.97423 5.47381 6.31337 5.33334 6.66699 5.33334H12.0003C12.3539 5.33334 12.6931 5.47381 12.9431 5.72386C13.1932 5.97391 13.3337 6.31305 13.3337 6.66667V12C13.3337 12.3536 13.1932 12.6928 12.9431 12.9428C12.6931 13.1929 12.3539 13.3333 12.0003 13.3333H6.66699C6.31337 13.3333 5.97423 13.1929 5.72418 12.9428C5.47413 12.6928 5.33366 12.3536 5.33366 12V6.66667Z",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
CopyIconDouble.displayName = "Icons.CopyIconDouble";

export { CopyIconDouble };
//# sourceMappingURL=CopyIconDouble.js.map
